
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexqkPOiBNJxbJ_45hL80X5gdGd0I5TSJhiKk1NZu70opkE0Meta } from "/codebuild/output/src3844900213/src/zazos-web/pages/index.vue?macro=true";
import { default as indexk7qqctgKQ1Dl_45EhLs7o_45W9B6jEGREVbRulNtBvaIsh0Meta } from "/codebuild/output/src3844900213/src/zazos-web/pages/login/index.vue?macro=true";
import { default as set_45workspacemIMMRduP3kPv8nArwng9N09vl2Kde2c_OVHaogH1HQAMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/set-workspace.vue?macro=true";
import { default as indexK_45OmM7rxAG4zbWJ_ug7V_45ryyp_ft56vmF4aosKNHCDgMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/sign-up/index.vue?macro=true";
import { default as index0IV_45mP0ClwiS4rCu6EMzVJ_9COgQi_oufBlS1bR7S68Meta } from "/codebuild/output/src3844900213/src/zazos-web/pages/magic-link/index.vue?macro=true";
import { default as indexZ7h__0_45SgzyVwXdhIAgEBdyAHuy7TJcT0akmNI07bp8Meta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/m/index.vue?macro=true";
import { default as indexQJmde4_45H595k42mDcS5eQxiQd_455TUGLh3ZvPwalHLQ8Meta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/index.vue?macro=true";
import { default as newr4yenPNajUHtz3ula5QgBDFtadOmCRjWOPCe_45s6xVssMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/new.vue?macro=true";
import { default as account_45configuration8jATu0bsL_45rDCD8Rrj0LovGyEILQDSsyoOA6ZBFhq38Meta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/m/account-configuration.vue?macro=true";
import { default as indexxQjXP_LkU9auZqXaaiwFE1LKx21zhF3ypx206xtQ3ZIMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/[recordId]/index.vue?macro=true";
import { default as mU7oIC_NmOcgDvAdj7J4QeDKKsWxk3mVKWS0kgnOpm3UMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/m.vue?macro=true";
import { default as index1vnijqPWHWSVPpv_y5fXJ8Dmk4Gym_9CVvNBYHjoSUMMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/reset-password/index.vue?macro=true";
import { default as indexpIGVclmJzwsloKrmmIAWT_u5APacazezku5dAlU4wp0Meta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/index.vue?macro=true";
import { default as index6UUpMVCJItCCbiYBqJYmZGxKLhjOFV7LLzd6TjM5dksMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/index.vue?macro=true";
import { default as indexNGNedZv1Gi0tKgxsyhJmbJwD9BkTT6jrpZYPswXVKyYMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/index.vue?macro=true";
import { default as user_45signuptZiju4MVMwRg9zFJ_pI_45qsReqQffcvl_wzFpWXoKDiQMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-signup.vue?macro=true";
import { default as indexb9Yro0lwmzz_45sLOtIcMqWEiddojoSY4UIXR1HgiFj2sMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/users/index.vue?macro=true";
import { default as indexHTjPLmLDhiO2uft6JNiNFcTJpFaJEhDKRPTLottzMSkMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/tokens/index.vue?macro=true";
import { default as indexK0Tu_tNsmMm9M4ORYD8_RVW_r1lz2RZzIzgcsOriVhQMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/internal/index.vue?macro=true";
import { default as newjejmj70GVth7AXpz4pipZWolipJpwivzN1vfVWsno_kMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/new.vue?macro=true";
import { default as _91id_93YdwkPEQ25ttYO4HLFiXxGRBmelscImbM1MbkecRW_akMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/[id].vue?macro=true";
import { default as index3SaPWBjqKheqKeQt4fB7y_ipNh4jCwPmShFJ_45UZsHvQMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/app-builder/index.vue?macro=true";
import { default as indexvFlG2OTMZiXaNzz68gPbisiWGZMA2RwWt1mTRA03c_45cMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/export-data/index.vue?macro=true";
import { default as indexjqSrQOJi_45WWrUac5kaYSTRDxyFFF9KkI1XYPgDAdHfsMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/index.vue?macro=true";
import { default as indexrca7R96JsGLMjWxeFBVTBTAF_r2XkL6uSupR1pclNzwMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/index.vue?macro=true";
import { default as indexcF7wdjtVtgD1m61rUlvWvo7pG8yQCYrOFVuupyErVGIMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/authentication/index.vue?macro=true";
import { default as indexuhPtTZnwIobY5BfMTMDtTxDQ9A_45LpsXTQGTLIYwM8I0Meta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/email-analytics/index.vue?macro=true";
import { default as indexzs6a9NJIPQcRN3cdigJLzEe2JkoWla4cvQQ2ViX4f64Meta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/system-entities/index.vue?macro=true";
import { default as _91providerSlug_93_45fDIsLwCA7taKE_45D02ZN23ZOOm06LPNnhc_45o1RC7N_MMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/[providerSlug].vue?macro=true";
import { default as indexjUVoD19mQvhW5rzFZQR0qdq_j1sqF4Ap1hHsA9YvNYoMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/global-parameters-manager/index.vue?macro=true";
import { default as settingsSgA0rDPPhUORLsETVhQzUvPMDJbpOKv8Hd5EHcuWcekMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings.vue?macro=true";
import { default as indexp94Vb0TGXv5ilDnPGk5EtTAHwZC2HsPVFyzjWbjV8TYMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/data/index.vue?macro=true";
import { default as _91id_93IDQSr3I1krMkLH7T83Q4YIB6bA5AcRu8wNyxGnrWuIMMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/pages/[id].vue?macro=true";
import { default as indexZi3GRfXM1XYimkYEAY8s8MxtttQNLz9O38DxipS8fw0Meta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/pages/index.vue?macro=true";
import { default as index5gHhU2XNexx_45C8M1mTlRC354AEejnuiWk06_065CgUUMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/index.vue?macro=true";
import { default as importbuc_dFZMjyFFzjZwPhiJ_UMtpJiLswafjqPeLMdiO3cMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/import.vue?macro=true";
import { default as schemaqFXNXhLSUsS26244yxK4WdlQzo9Q4dhUfgWWTrKGb3kMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/schema.vue?macro=true";
import { default as indexpij2IAlXN9F4jjyZ58zz5Wdf9dgcrSXYB74Eb2BsHWIMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/automations/index.vue?macro=true";
import { default as indexWRucR96lAZQ0_45ej_W_45CaXswK6HZzBx5W7qp6dUVY2o8Meta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/index.vue?macro=true";
import { default as historyhSCVpbg9KZNRyZ5_kWn3YADTclQtAgP8spaASJRI8UcMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/history.vue?macro=true";
import { default as studio_bfih0GDzxkD5Mb_45i0nLSOVlxiNmHPcANqWUYwB0uY0Meta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio.vue?macro=true";
import { default as indexu_nQIskRAuTccusHKO_4OS7VMG2XygfEo9eu53e0LM4Meta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/p/index.vue?macro=true";
import { default as indexu13Y3u3ANMdvPXlSV51BWG5rLzBNxPdvqXZ09XJbZzcMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/mfa/index.vue?macro=true";
import { default as index_45xLRiLGB5D3fwkYfL0Yp_45HGVoA_45h1DPMzxLXDo23zckMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/login/index.vue?macro=true";
import { default as indexx7L2qo1DODbc2KLSaYWn21aLBSCIAX_45JiGPynaFaPaQMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/store/index.vue?macro=true";
import { default as _91app_93t7qU0H6q1xs2HyLD283m1V2kcFMFa_xL1etcz7ucz0wMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/install/[app].vue?macro=true";
import { default as indexext23VvqJfUmNKAnmukL0oP4xcYNFI8h_45dgQdMJw1zkMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/loading/index.vue?macro=true";
import { default as indextZaZXzsPYuRmLefVcMmfAaHKuAxD9mdArDhAqYZmhiUMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/sign-up/index.vue?macro=true";
import { default as reset_45passwordAd5M4q3dq28n1LpLM_45RF8fbL4XIEmdsvOM8odzN368YMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/reset-password.vue?macro=true";
import { default as indexKkQbCSUY6M0ptMeoZBkx_45HU8g9FpMCC9Ty9ybAP_e8sMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/sso/saml/index.vue?macro=true";
import { default as indexipRMf4_45ysh4OIu_454SXBIq4tEeJRytffcaCMmAAskn0MMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/mfa/setup/index.vue?macro=true";
import { default as indexlDi9r5PRFVyvjmej_45Gc1blqI43u04PerLCN9_PZ7dO0Meta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/index.vue?macro=true";
import { default as _91appName_93f_eansauDlBsws9qNy_2GOdklykiiqCg9OtXKD8mkpgMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/store/apps/[appName].vue?macro=true";
import { default as indexmPZyV0nKvWy5VlgThYOqG82zJDwnZvxfvICgyREw524Meta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/install/-review/index.vue?macro=true";
import { default as indexfzasZ4I6gNANmnEuhH08ErvXKvY_45G8IY9GOLWsucIHcMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/email-validation/index.vue?macro=true";
import { default as indexojG95cfZUPBEf75sEQtAERF9nq2jmjmG7w9Na5pNBJgMeta } from "/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/r/[recordId]/index.vue?macro=true";
export default [
  {
    name: "index___en",
    path: "/en",
    meta: indexqkPOiBNJxbJ_45hL80X5gdGd0I5TSJhiKk1NZu70opkE0Meta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/",
    meta: indexqkPOiBNJxbJ_45hL80X5gdGd0I5TSJhiKk1NZu70opkE0Meta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/index.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/login/index.vue")
  },
  {
    name: "login___pt",
    path: "/login",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/login/index.vue")
  },
  {
    name: "set-workspace___en",
    path: "/en/set-workspace",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/set-workspace.vue")
  },
  {
    name: "set-workspace___pt",
    path: "/set-workspace",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/set-workspace.vue")
  },
  {
    name: "sign-up___en",
    path: "/en/sign-up",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/sign-up/index.vue")
  },
  {
    name: "sign-up___pt",
    path: "/sign-up",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/sign-up/index.vue")
  },
  {
    name: "magic-link___en",
    path: "/en/magic-link",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/magic-link/index.vue")
  },
  {
    name: "magic-link___pt",
    path: "/magic-link",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/magic-link/index.vue")
  },
  {
    name: mU7oIC_NmOcgDvAdj7J4QeDKKsWxk3mVKWS0kgnOpm3UMeta?.name,
    path: "/en/t/:tenantSlug()/m",
    meta: mU7oIC_NmOcgDvAdj7J4QeDKKsWxk3mVKWS0kgnOpm3UMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/m.vue"),
    children: [
  {
    name: "t-tenantSlug-m___en",
    path: "",
    meta: indexZ7h__0_45SgzyVwXdhIAgEBdyAHuy7TJcT0akmNI07bp8Meta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/m/index.vue")
  },
  {
    name: "t-tenantSlug-m-viewId___en",
    path: ":viewId()",
    meta: indexQJmde4_45H595k42mDcS5eQxiQd_455TUGLh3ZvPwalHLQ8Meta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/index.vue")
  },
  {
    name: "t-tenantSlug-m-viewId-r-new___en",
    path: ":viewId()/r/new",
    meta: newr4yenPNajUHtz3ula5QgBDFtadOmCRjWOPCe_45s6xVssMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/new.vue")
  },
  {
    name: "t-tenantSlug-m-account-configuration___en",
    path: "account-configuration",
    meta: account_45configuration8jATu0bsL_45rDCD8Rrj0LovGyEILQDSsyoOA6ZBFhq38Meta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/m/account-configuration.vue")
  },
  {
    name: "t-tenantSlug-m-viewId-r-recordId___en",
    path: ":viewId()/r/:recordId()",
    meta: indexxQjXP_LkU9auZqXaaiwFE1LKx21zhF3ypx206xtQ3ZIMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/[recordId]/index.vue")
  }
]
  },
  {
    name: mU7oIC_NmOcgDvAdj7J4QeDKKsWxk3mVKWS0kgnOpm3UMeta?.name,
    path: "/t/:tenantSlug()/m",
    meta: mU7oIC_NmOcgDvAdj7J4QeDKKsWxk3mVKWS0kgnOpm3UMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/m.vue"),
    children: [
  {
    name: "t-tenantSlug-m___pt",
    path: "",
    meta: indexZ7h__0_45SgzyVwXdhIAgEBdyAHuy7TJcT0akmNI07bp8Meta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/m/index.vue")
  },
  {
    name: "t-tenantSlug-m-viewId___pt",
    path: ":viewId()",
    meta: indexQJmde4_45H595k42mDcS5eQxiQd_455TUGLh3ZvPwalHLQ8Meta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/index.vue")
  },
  {
    name: "t-tenantSlug-m-viewId-r-new___pt",
    path: ":viewId()/r/new",
    meta: newr4yenPNajUHtz3ula5QgBDFtadOmCRjWOPCe_45s6xVssMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/new.vue")
  },
  {
    name: "t-tenantSlug-m-account-configuration___pt",
    path: "account-configuration",
    meta: account_45configuration8jATu0bsL_45rDCD8Rrj0LovGyEILQDSsyoOA6ZBFhq38Meta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/m/account-configuration.vue")
  },
  {
    name: "t-tenantSlug-m-viewId-r-recordId___pt",
    path: ":viewId()/r/:recordId()",
    meta: indexxQjXP_LkU9auZqXaaiwFE1LKx21zhF3ypx206xtQ3ZIMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/[recordId]/index.vue")
  }
]
  },
  {
    name: "reset-password___en",
    path: "/en/reset-password",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/reset-password/index.vue")
  },
  {
    name: "reset-password___pt",
    path: "/reset-password",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/reset-password/index.vue")
  },
  {
    name: "t-tenantSlug___en",
    path: "/en/t/:tenantSlug()",
    meta: indexpIGVclmJzwsloKrmmIAWT_u5APacazezku5dAlU4wp0Meta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/index.vue")
  },
  {
    name: "t-tenantSlug___pt",
    path: "/t/:tenantSlug()",
    meta: indexpIGVclmJzwsloKrmmIAWT_u5APacazezku5dAlU4wp0Meta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/index.vue")
  },
  {
    name: studio_bfih0GDzxkD5Mb_45i0nLSOVlxiNmHPcANqWUYwB0uY0Meta?.name,
    path: "/en/t/:tenantSlug()/studio",
    meta: studio_bfih0GDzxkD5Mb_45i0nLSOVlxiNmHPcANqWUYwB0uY0Meta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio.vue"),
    children: [
  {
    name: "t-tenantSlug-studio___en",
    path: "",
    meta: index6UUpMVCJItCCbiYBqJYmZGxKLhjOFV7LLzd6TjM5dksMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/index.vue")
  },
  {
    name: settingsSgA0rDPPhUORLsETVhQzUvPMDJbpOKv8Hd5EHcuWcekMeta?.name,
    path: "settings",
    meta: settingsSgA0rDPPhUORLsETVhQzUvPMDJbpOKv8Hd5EHcuWcekMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings.vue"),
    children: [
  {
    name: "t-tenantSlug-studio-settings___en",
    path: "",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-signup___en",
    path: "user-signup",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-signup.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-users___en",
    path: "users",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/users/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-tokens___en",
    path: "tokens",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/tokens/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-internal___en",
    path: "internal",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/internal/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups-new___en",
    path: "user-groups/new",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/new.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups-id___en",
    path: "user-groups/:id()",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/[id].vue")
  },
  {
    name: "t-tenantSlug-studio-settings-app-builder___en",
    path: "app-builder",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/app-builder/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-export-data___en",
    path: "export-data",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/export-data/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups___en",
    path: "user-groups",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-integrations___en",
    path: "integrations",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-authentication___en",
    path: "authentication",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/authentication/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-email-analytics___en",
    path: "email-analytics",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/email-analytics/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-system-entities___en",
    path: "system-entities",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/system-entities/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-integrations-providerSlug___en",
    path: "integrations/:providerSlug()",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/[providerSlug].vue")
  },
  {
    name: "t-tenantSlug-studio-settings-global-parameters-manager___en",
    path: "global-parameters-manager",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/global-parameters-manager/index.vue")
  }
]
  },
  {
    name: "t-tenantSlug-studio-data___en",
    path: "data",
    meta: indexp94Vb0TGXv5ilDnPGk5EtTAHwZC2HsPVFyzjWbjV8TYMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/data/index.vue")
  },
  {
    name: "t-tenantSlug-studio-pages-id___en",
    path: "pages/:id()",
    meta: _91id_93IDQSr3I1krMkLH7T83Q4YIB6bA5AcRu8wNyxGnrWuIMMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/pages/[id].vue")
  },
  {
    name: "t-tenantSlug-studio-pages___en",
    path: "pages",
    meta: indexZi3GRfXM1XYimkYEAY8s8MxtttQNLz9O38DxipS8fw0Meta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/pages/index.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id___en",
    path: "data/:id()",
    meta: index5gHhU2XNexx_45C8M1mTlRC354AEejnuiWk06_065CgUUMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/index.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id-import___en",
    path: "data/:id()/import",
    meta: importbuc_dFZMjyFFzjZwPhiJ_UMtpJiLswafjqPeLMdiO3cMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/import.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id-schema___en",
    path: "data/:id()/schema",
    meta: schemaqFXNXhLSUsS26244yxK4WdlQzo9Q4dhUfgWWTrKGb3kMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/schema.vue")
  },
  {
    name: "t-tenantSlug-studio-automations___en",
    path: "automations",
    meta: indexpij2IAlXN9F4jjyZ58zz5Wdf9dgcrSXYB74Eb2BsHWIMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/automations/index.vue")
  },
  {
    name: "t-tenantSlug-studio-automations-id___en",
    path: "automations/:id()",
    meta: indexWRucR96lAZQ0_45ej_W_45CaXswK6HZzBx5W7qp6dUVY2o8Meta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/index.vue")
  },
  {
    name: "t-tenantSlug-studio-automations-id-history___en",
    path: "automations/:id()/history",
    meta: historyhSCVpbg9KZNRyZ5_kWn3YADTclQtAgP8spaASJRI8UcMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/history.vue")
  }
]
  },
  {
    name: studio_bfih0GDzxkD5Mb_45i0nLSOVlxiNmHPcANqWUYwB0uY0Meta?.name,
    path: "/t/:tenantSlug()/studio",
    meta: studio_bfih0GDzxkD5Mb_45i0nLSOVlxiNmHPcANqWUYwB0uY0Meta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio.vue"),
    children: [
  {
    name: "t-tenantSlug-studio___pt",
    path: "",
    meta: index6UUpMVCJItCCbiYBqJYmZGxKLhjOFV7LLzd6TjM5dksMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/index.vue")
  },
  {
    name: settingsSgA0rDPPhUORLsETVhQzUvPMDJbpOKv8Hd5EHcuWcekMeta?.name,
    path: "settings",
    meta: settingsSgA0rDPPhUORLsETVhQzUvPMDJbpOKv8Hd5EHcuWcekMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings.vue"),
    children: [
  {
    name: "t-tenantSlug-studio-settings___pt",
    path: "",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-signup___pt",
    path: "user-signup",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-signup.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-users___pt",
    path: "users",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/users/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-tokens___pt",
    path: "tokens",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/tokens/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-internal___pt",
    path: "internal",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/internal/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups-new___pt",
    path: "user-groups/new",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/new.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups-id___pt",
    path: "user-groups/:id()",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/[id].vue")
  },
  {
    name: "t-tenantSlug-studio-settings-app-builder___pt",
    path: "app-builder",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/app-builder/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-export-data___pt",
    path: "export-data",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/export-data/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups___pt",
    path: "user-groups",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-integrations___pt",
    path: "integrations",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-authentication___pt",
    path: "authentication",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/authentication/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-email-analytics___pt",
    path: "email-analytics",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/email-analytics/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-system-entities___pt",
    path: "system-entities",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/system-entities/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-integrations-providerSlug___pt",
    path: "integrations/:providerSlug()",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/[providerSlug].vue")
  },
  {
    name: "t-tenantSlug-studio-settings-global-parameters-manager___pt",
    path: "global-parameters-manager",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/settings/global-parameters-manager/index.vue")
  }
]
  },
  {
    name: "t-tenantSlug-studio-data___pt",
    path: "data",
    meta: indexp94Vb0TGXv5ilDnPGk5EtTAHwZC2HsPVFyzjWbjV8TYMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/data/index.vue")
  },
  {
    name: "t-tenantSlug-studio-pages-id___pt",
    path: "pages/:id()",
    meta: _91id_93IDQSr3I1krMkLH7T83Q4YIB6bA5AcRu8wNyxGnrWuIMMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/pages/[id].vue")
  },
  {
    name: "t-tenantSlug-studio-pages___pt",
    path: "pages",
    meta: indexZi3GRfXM1XYimkYEAY8s8MxtttQNLz9O38DxipS8fw0Meta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/pages/index.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id___pt",
    path: "data/:id()",
    meta: index5gHhU2XNexx_45C8M1mTlRC354AEejnuiWk06_065CgUUMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/index.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id-import___pt",
    path: "data/:id()/import",
    meta: importbuc_dFZMjyFFzjZwPhiJ_UMtpJiLswafjqPeLMdiO3cMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/import.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id-schema___pt",
    path: "data/:id()/schema",
    meta: schemaqFXNXhLSUsS26244yxK4WdlQzo9Q4dhUfgWWTrKGb3kMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/schema.vue")
  },
  {
    name: "t-tenantSlug-studio-automations___pt",
    path: "automations",
    meta: indexpij2IAlXN9F4jjyZ58zz5Wdf9dgcrSXYB74Eb2BsHWIMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/automations/index.vue")
  },
  {
    name: "t-tenantSlug-studio-automations-id___pt",
    path: "automations/:id()",
    meta: indexWRucR96lAZQ0_45ej_W_45CaXswK6HZzBx5W7qp6dUVY2o8Meta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/index.vue")
  },
  {
    name: "t-tenantSlug-studio-automations-id-history___pt",
    path: "automations/:id()/history",
    meta: historyhSCVpbg9KZNRyZ5_kWn3YADTclQtAgP8spaASJRI8UcMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/history.vue")
  }
]
  },
  {
    name: "t-tenantSlug-p___en",
    path: "/en/t/:tenantSlug()/p",
    meta: indexu_nQIskRAuTccusHKO_4OS7VMG2XygfEo9eu53e0LM4Meta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/p/index.vue")
  },
  {
    name: "t-tenantSlug-p___pt",
    path: "/t/:tenantSlug()/p",
    meta: indexu_nQIskRAuTccusHKO_4OS7VMG2XygfEo9eu53e0LM4Meta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/p/index.vue")
  },
  {
    name: "t-tenantSlug-mfa___en",
    path: "/en/t/:tenantSlug()/mfa",
    meta: indexu13Y3u3ANMdvPXlSV51BWG5rLzBNxPdvqXZ09XJbZzcMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/mfa/index.vue")
  },
  {
    name: "t-tenantSlug-mfa___pt",
    path: "/t/:tenantSlug()/mfa",
    meta: indexu13Y3u3ANMdvPXlSV51BWG5rLzBNxPdvqXZ09XJbZzcMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/mfa/index.vue")
  },
  {
    name: "t-tenantSlug-login___en",
    path: "/en/t/:tenantSlug()/login",
    meta: index_45xLRiLGB5D3fwkYfL0Yp_45HGVoA_45h1DPMzxLXDo23zckMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/login/index.vue")
  },
  {
    name: "t-tenantSlug-login___pt",
    path: "/t/:tenantSlug()/login",
    meta: index_45xLRiLGB5D3fwkYfL0Yp_45HGVoA_45h1DPMzxLXDo23zckMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/login/index.vue")
  },
  {
    name: "t-tenantSlug-store___en",
    path: "/en/t/:tenantSlug()/store",
    meta: indexx7L2qo1DODbc2KLSaYWn21aLBSCIAX_45JiGPynaFaPaQMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/store/index.vue")
  },
  {
    name: "t-tenantSlug-store___pt",
    path: "/t/:tenantSlug()/store",
    meta: indexx7L2qo1DODbc2KLSaYWn21aLBSCIAX_45JiGPynaFaPaQMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/store/index.vue")
  },
  {
    name: "t-tenantSlug-install-app___en",
    path: "/en/t/:tenantSlug()/install/:app()",
    meta: _91app_93t7qU0H6q1xs2HyLD283m1V2kcFMFa_xL1etcz7ucz0wMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/install/[app].vue")
  },
  {
    name: "t-tenantSlug-install-app___pt",
    path: "/t/:tenantSlug()/install/:app()",
    meta: _91app_93t7qU0H6q1xs2HyLD283m1V2kcFMFa_xL1etcz7ucz0wMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/install/[app].vue")
  },
  {
    name: "t-tenantSlug-loading___en",
    path: "/en/t/:tenantSlug()/loading",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/loading/index.vue")
  },
  {
    name: "t-tenantSlug-loading___pt",
    path: "/t/:tenantSlug()/loading",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/loading/index.vue")
  },
  {
    name: "t-tenantSlug-sign-up___en",
    path: "/en/t/:tenantSlug()/sign-up",
    meta: indextZaZXzsPYuRmLefVcMmfAaHKuAxD9mdArDhAqYZmhiUMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/sign-up/index.vue")
  },
  {
    name: "t-tenantSlug-sign-up___pt",
    path: "/t/:tenantSlug()/sign-up",
    meta: indextZaZXzsPYuRmLefVcMmfAaHKuAxD9mdArDhAqYZmhiUMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/sign-up/index.vue")
  },
  {
    name: "t-tenantSlug-reset-password___en",
    path: "/en/t/:tenantSlug()/reset-password",
    meta: reset_45passwordAd5M4q3dq28n1LpLM_45RF8fbL4XIEmdsvOM8odzN368YMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/reset-password.vue")
  },
  {
    name: "t-tenantSlug-reset-password___pt",
    path: "/t/:tenantSlug()/reset-password",
    meta: reset_45passwordAd5M4q3dq28n1LpLM_45RF8fbL4XIEmdsvOM8odzN368YMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/reset-password.vue")
  },
  {
    name: "t-tenantSlug-sso-saml___en",
    path: "/en/t/:tenantSlug()/sso/saml",
    meta: indexKkQbCSUY6M0ptMeoZBkx_45HU8g9FpMCC9Ty9ybAP_e8sMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/sso/saml/index.vue")
  },
  {
    name: "t-tenantSlug-sso-saml___pt",
    path: "/t/:tenantSlug()/sso/saml",
    meta: indexKkQbCSUY6M0ptMeoZBkx_45HU8g9FpMCC9Ty9ybAP_e8sMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/sso/saml/index.vue")
  },
  {
    name: "t-tenantSlug-mfa-setup___en",
    path: "/en/t/:tenantSlug()/mfa/setup",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/mfa/setup/index.vue")
  },
  {
    name: "t-tenantSlug-mfa-setup___pt",
    path: "/t/:tenantSlug()/mfa/setup",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/mfa/setup/index.vue")
  },
  {
    name: "t-tenantSlug-p-viewId___en",
    path: "/en/t/:tenantSlug()/p/:viewId()",
    meta: indexlDi9r5PRFVyvjmej_45Gc1blqI43u04PerLCN9_PZ7dO0Meta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/index.vue")
  },
  {
    name: "t-tenantSlug-p-viewId___pt",
    path: "/t/:tenantSlug()/p/:viewId()",
    meta: indexlDi9r5PRFVyvjmej_45Gc1blqI43u04PerLCN9_PZ7dO0Meta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/index.vue")
  },
  {
    name: "t-tenantSlug-store-apps-appName___en",
    path: "/en/t/:tenantSlug()/store/apps/:appName()",
    meta: _91appName_93f_eansauDlBsws9qNy_2GOdklykiiqCg9OtXKD8mkpgMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/store/apps/[appName].vue")
  },
  {
    name: "t-tenantSlug-store-apps-appName___pt",
    path: "/t/:tenantSlug()/store/apps/:appName()",
    meta: _91appName_93f_eansauDlBsws9qNy_2GOdklykiiqCg9OtXKD8mkpgMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/store/apps/[appName].vue")
  },
  {
    name: "t-tenantSlug-install--review___en",
    path: "/en/t/:tenantSlug()/install/-review",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/install/-review/index.vue")
  },
  {
    name: "t-tenantSlug-install--review___pt",
    path: "/t/:tenantSlug()/install/-review",
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/install/-review/index.vue")
  },
  {
    name: "t-tenantSlug-email-validation___en",
    path: "/en/t/:tenantSlug()/email-validation",
    meta: indexfzasZ4I6gNANmnEuhH08ErvXKvY_45G8IY9GOLWsucIHcMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/email-validation/index.vue")
  },
  {
    name: "t-tenantSlug-email-validation___pt",
    path: "/t/:tenantSlug()/email-validation",
    meta: indexfzasZ4I6gNANmnEuhH08ErvXKvY_45G8IY9GOLWsucIHcMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/email-validation/index.vue")
  },
  {
    name: "t-tenantSlug-p-viewId-r-recordId___en",
    path: "/en/t/:tenantSlug()/p/:viewId()/r/:recordId()",
    meta: indexojG95cfZUPBEf75sEQtAERF9nq2jmjmG7w9Na5pNBJgMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/r/[recordId]/index.vue")
  },
  {
    name: "t-tenantSlug-p-viewId-r-recordId___pt",
    path: "/t/:tenantSlug()/p/:viewId()/r/:recordId()",
    meta: indexojG95cfZUPBEf75sEQtAERF9nq2jmjmG7w9Na5pNBJgMeta || {},
    component: () => import("/codebuild/output/src3844900213/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/r/[recordId]/index.vue")
  }
]